import UsersIcon from '@material-ui/icons/PeopleAlt'

export default [
  {
    title: 'sidebar.title.admin', pages: [
      { title: 'sidebar.item.users', icon: UsersIcon, href: '/admin/users' },
    ]
  },
]